
function isDeployedEnv() {
  return ['production', 'beta', 'staging'].includes(process.env.NODE_ENV);
}

export {
  isDeployedEnv,
};
